import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Icon from 'components/common/Icon/Icon'
import Link from 'components/common/Link/Link'

const FleetCertified = ({
  isHovering,
  setIsHovering,
  className,
  isTooltipHovering,
  setIsTooltipHovering,
  showModal,
  showModalOnHover
}) =>
  <Wrapper className={ className }>
    <Media.Desktop>
      <FleetServicesLink
        to="/fleet-services"
        onMouseEnter={ () => setIsHovering(true) }
        onMouseLeave={ () => setIsHovering(false) }>
        <Icon
          asset={ isHovering ? 'fleet-certified-icon-green' : 'fleet-certified-icon-gold' }
          alt="Fleet Service Icon" />

        <LinkText isHovering={ isHovering }>
          Learn More
        </LinkText>
      </FleetServicesLink>

      <InfoIcon
        width="18"
        asset={ isTooltipHovering ? 'icon-info-blue-solid' : 'icon-info-blue-regular' }
        alt="Tooltip Icon"
        onMouseEnter={ showModalOnHover }
        onMouseLeave={ () => setIsTooltipHovering(false) }
        onClick={ showModal } />
    </Media.Desktop>

    <Media.Mobile>
      <MobileTextWrapper>
        <MobileText>
          Fleet Certified Store
        </MobileText>

        <MobileLink to="/fleet-services">
          Learn More
        </MobileLink>
      </MobileTextWrapper>

      <InfoIcon
        width="16"
        asset={ 'icon-info-blue-regular' }
        alt="Tooltip Icon"
        onClick={ showModal } />

      <MobileFleetServiceLogo
        width="70"
        asset={ 'fleet-certified-icon-gold' }
        alt="Fleet Service Icon" />
    </Media.Mobile>
  </Wrapper>

FleetCertified.propTypes = {
  className: PropTypes.string,
  isHovering: PropTypes.bool,
  isTooltipHovering: PropTypes.bool,
  setIsHovering: PropTypes.func,
  setIsTooltipHovering: PropTypes.func,
  showModal: PropTypes.func,
  showModalOnHover: PropTypes.func
}

export default FleetCertified

const Wrapper = styled.div`
  position: relative;
  width: 110px;
  ${Media.mobile`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 5px 0;
    border-top: 1px solid ${Theme.colors.light_grey};
  `}
`

const MobileTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const MobileText = styled.p`
  margin: 0;
  padding: 0;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 15px;
`

const FleetServicesLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${Theme.colors.blue};
`

const LinkText = styled.p`
  margin: 0;
  padding: 0;
  font-weight: 600;
  ${props => props.isHovering && css`
    color: ${Theme.colors.green}
  `}
`

const MobileLink = styled(Link)`
  text-decoration: underline;
  color: ${Theme.colors.blue};
  font-weight: 500;
`

const InfoIcon = styled(Icon)`
  position: absolute;
  right: -10px;
  bottom: 0;
  cursor: pointer;
  ${Media.mobile`
    position: static;
    right: unset;
    bottom: unset;
    margin: 0 0 16px 8px;
  `}
`

const MobileFleetServiceLogo = styled(Icon)`
  margin-left: auto;
`
